const PrescriptionPad = () => /* webpackChunkName: "EmptyRouterView" */ import("@/views/mental_health_pharmacy/prescriptionPad/PrescriptionPad.vue");
const EmptyRouterView = () => /* webpackChunkName: "EmptyRouterView" */ import("./../views/mental_health_pharmacy/EmptyRouterView.vue");
const MentalMedicHealthHome = () => /* webpackChunkName: "Home" */ import("./../views/mental_health_pharmacy/Home.vue");
const MedicAtention = () => /* webpackChunkName: "medicAtentions" */ import("./../views/mental_health_pharmacy/medic_atention/medic_Atentions.vue");
const ManteinerArticle = () => /* webpackChunkName: "Home" */ import("./../views/mental_health_pharmacy/articles_node/Home.vue");
const PatientHome = () => /* webpackChunkName: "PatientHome" */ import("./../views/mental_health_pharmacy/patient/PatientHome.vue");
const Document = () => /* webpackChunkName: "Document" */ import("@/views/general/Document.vue");

export const routes = [
  {
    path: "/mental_health_pharmacy",
    component: EmptyRouterView,
    children: [
      {
        path: "",
        name: "mentalHealthPharmacyHome",
        component: MentalMedicHealthHome,
      },
      {
        path: "atencionMedica",
        name: "mentalHealthPharmacyMedicAtention",
        component: MedicAtention,
      },
      {
        path: "mantenedor-articulos",
        name: "mentalHealthPharmacyMaintainerArticle",
        component: ManteinerArticle,
      },
      {
        path: "gestor-pacientes",
        name: "mentalHealthPharmacyPatientHome",
        component: PatientHome,
      },
      {
        path: "documentacion",
        name: "mentalHealthPharmacyDocumentation",
        component: Document,
      },
      {
        path: "talonario",
        name: "mentalHealthPharmacyPrescriptionPad",
        component: PrescriptionPad,
      },
    ],
  },
];
